import { isDurableNovaChatCompletionsEndpoint } from './transport';

interface RecoverableStreamChat {
  uuid?: string | null;
  activeStreamId?: string | null;
}

export function shouldRecoverOrphanedStream({
  apiEndpoint,
  chat,
  currentChatUuid,
}: {
  apiEndpoint: string;
  chat: RecoverableStreamChat;
  currentChatUuid?: string;
}) {
  if (!chat.uuid || !chat.activeStreamId) {
    return false;
  }

  if (isDurableNovaChatCompletionsEndpoint(apiEndpoint) && !chat.activeStreamId.startsWith('wrun_')) {
    return false;
  }

  const chatUuidWithoutPrefix = currentChatUuid?.replace('new-chat-', '');

  return chat.uuid !== chatUuidWithoutPrefix;
}
